// extracted by mini-css-extract-plugin
export var container = "layout-module--container--3nGj0";
export var content = "layout-module--content--bviAP";